module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"actionTitle":"Alınacak Aksiyon","files":"Dosyalar","negativeControl":"Olumsuz Kontrol","itemType":"Madde türü","openTicket":"Açık","closedTicket":"Kapalı","Audit":"Düzeltici Faaliyet","AuditGaranti":"Uygunsuzluk Maddesi","Action":"Önleyici Faaliyet","ActionGaranti":"Aksiyon Planı"},"en":{"actionTitle":"Action","files":"Files","negativeControl":"Negative Control","itemType":"Type","openTicket":"Open","closedTicket":"Closed","Audit":"Corrective Action","Action":"Preventive Action","AuditGaranti":"Corrective Action","ActionGaranti":"Action plan"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/views/Audit/Audits/TicketDetail.vue
// module id = Q8WP
// module chunks = 1